export default {
    "defaultVideos": [
    	{
            "title": "Hallicunaties: Dhr. v. Elburg",
            "assets": {
                "imageURL": "shared/algemeen0.jpg",
                "videoURL": "algemeen0.flv"
            }
        },
        {
            "title": "Melkbussen: Dhr. Kersten",
            "assets": {
                "imageURL": "shared/algemeen1.jpg",
                "videoURL": "algemeen1.flv"
            }
        },
        {
            "title": "De wandeling: Dhr. Kersten",
            "assets": {
                "imageURL": "shared/algemeen2.jpg",
                "videoURL": "algemeen2.flv"
            }
        }
    ],
    "videos": [
        {
            "id": "acties.actie.communiceren.orientatievragenstellen.tip",
            "title": "Ori&euml;nterende vragen stellen: Dhr. v. Elburg",
            "assets": {
                "imageURL": "shared/orientatievragenstellen.jpg",
                "videoURL": "orientatievragenstellen.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.patientvragennaardenacht.tip",
            "title": "Feestje: Dhr. de Vries",
            "assets": {
                "imageURL": "shared/patientvragennaardenacht.jpg",
                "videoURL": "patientvragennaardenacht.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.patientvragennaarnachtrust.tip",
            "title": "Donkere Gedaantes: Dhr. v. Blankers",
            "assets": {
                "imageURL": "shared/patientvragennaarnachtrust.jpg",
                "videoURL": "patientvragennaarnachtrust.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.patientwijzenoprealiteit.tip",
            "title": "Pati&euml;nt wijzen op de realiteit: Dhr. v. Elburg",
            "assets": {
                "imageURL": "shared/patientwijzenoprealiteit0.jpg",
                "videoURL": "patientwijzenoprealiteit0.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.vragenofdepatientweetwaarhijis.tip",
            "title": "Weet u waar u bent?: Dhr. v. Blankers",
            "assets": {
                "imageURL": "shared/vragenofdepatientweetwaarhijis.jpg",
                "videoURL": "vragenofdepatientweetwaarhijis.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.vragenwatdepatientheeftgezien.tip",
            "title": "Schimmen: Dhr. de Vries",
            "assets": {
                "imageURL": "shared/vragenwatdepatientheeftgezien.jpg",
                "videoURL": "vragenwatdepatientheeftgezien.flv"
            }
        },
        {
            "id": "acties.actie.klok.klokweghalen.tip",
            "title": "De klok: Dhr. Kersten",
            "assets": {
                "imageURL": "shared/klokweghalen.jpg",
                "videoURL": "klokweghalen.flv"
            }
        },
        {
            "id": "acties.actie.medicatietoedienen.medicatietoelichtenaanpatient.tip",
            "title": "Verbrande Kippetje: Mevr. Nieuwenhuis",
            "assets": {
                "imageURL": "shared/medicatietoelichtenaanpatient.jpg",
                "videoURL": "medicatietoelichtenaanpatient.flv"
            }
        },
        {
            "id": "acties.actie.whiteboard.uitvegen.tip",
            "title": "Whiteboard: Dhr. v. Blankers",
            "assets": {
                "imageURL": "shared/whiteboarduitvegen.jpg",
                "videoURL": "whiteboarduitvegen0.flv"
            }
        },
        {
            "id": "acties.actie.zweedseband.controlerenofzweedsebandvolgensprotocolisaangelegd.tip",
            "title": "Zweedse band: Mevr. Nieuwenhuis",
            "assets": {
                "imageURL": "shared/controlerenofzweedsebandvolgensprotocolisaangelegd.jpg",
                "videoURL": "controlerenofzweedsebandvolgensprotocolisaangelegd.flv"
            }
        },
        {
            "id": "acties.actie.zweedseband.zweedsebanduitdoenwanneerpartnerarriveert.tip",
            "title": "Zweedse band: Dhr. Kersten",
            "assets": {
                "imageURL": "shared/zweedsebanduitdoenwanneerpartnerarriveert.jpg",
                "videoURL": "zweedsebanduitdoenwanneerpartnerarriveert.flv"
            }
        }
    ]
}